import React from 'react';
import StartOverIcon from 'assets/figures/StartOver';
import { ButtonElement, Description, Figure, Content } from './StartOver.styled';
import { BUTTON } from '../../../constants/components';
import { localize } from '../../../core/localization';

type StartOverProps = {
  closePopup(): void;
  popupSettings: { [key: string]: any };
};

export const StartOver = (props: StartOverProps) => {
  const [restoreAttemptStarted, setRestoreAttemptStarted] = React.useState<boolean>(false);

  const startNewAttempt = async () => {
    if (!restoreAttemptStarted) {
      setRestoreAttemptStarted(true);
      props.popupSettings.navigateToIndex();
      await props.popupSettings.startNewAttempt();
      props.closePopup();
    }
  };

  return (
    <Content>
      <Figure>
        <StartOverIcon />
      </Figure>
      <Description>{localize('[start over description]')}</Description>
      <ButtonElement layout={BUTTON.LAYOUT.PRIMARY} onClick={startNewAttempt}>
        {localize('[start over]')}
      </ButtonElement>
    </Content>
  );
};

export default StartOver;
